import { Grid } from '@mui/material';
import { RoutalPalette, VSpacer } from '@nx-smartmonkey/ui';
import React from 'react';

import { Text } from '../../../../../react-components/Text';

interface StopFieldContainerProps {
  textId?: string;
  text?: string;
  showMandatory?: boolean;
}

export const StopFieldContainer = ({ textId, text, children }: React.PropsWithChildren<StopFieldContainerProps>) => {
  return (
    <Grid item style={{ display: `contents`, backgroundColor: RoutalPalette.white, width: `100%` }}>
      <Grid item style={{ display: `flex`, flexDirection: `row`, alignItems: `center` }}>
        {textId ? (
          <Text style={{ fontSize: `12px` }} variant="label" intlId={textId} />
        ) : (
          <Text style={{ fontSize: `12px` }} variant="label">
            {text}
          </Text>
        )}
      </Grid>
      <VSpacer small />
      {children}
    </Grid>
  );
};
